"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrandingService = void 0;
//ANGULAR2 BITS
const core_1 = require("@angular/core");
//INTERNAL LIBRARY BITS
const permission_service_1 = require("./permission.service");
let BrandingService = class BrandingService {
    constructor(_permission) {
        this._permission = _permission;
        this.BIDDR_CONNECT = "BiddR Connect";
        this.BIDDR_360 = "BiddR360";
    }
    isBiddrConnectLogin(href) {
        const body = document.getElementsByTagName("body")[0];
        const raw = body && body.dataset.baseurl;
        let baseURLData = null;
        if (raw) {
            try {
                baseURLData = JSON.parse(raw);
            }
            catch (_) {
                // ignore malformed JSON
            }
        }
        const base = baseURLData && baseURLData.biddrConnect;
        if (!base)
            return false;
        const loginURL = new URL("#/login", base.endsWith("/") ? base : base + "/")
            .href;
        let hrefNorm = href;
        try {
            hrefNorm = new URL(href, window.location.origin).href;
        }
        catch (_) { }
        return hrefNorm === loginURL;
    }
    getProductName() {
        if (this.useBiddr360Branding()) {
            return this.BIDDR_360;
        }
        if (this.useBiddrConnectBranding()) {
            return this.BIDDR_CONNECT;
        }
        return "";
    }
    showBillingDisclaimer() {
        return !this.useBiddr360Branding() && this.useBiddrConnectBranding();
    }
    useBiddrConnectBranding() {
        const permission = this._permission.get();
        return permission && permission["system-branding--biddr_connect"];
    }
    useBiddr360Branding() {
        const permission = this._permission.get();
        return permission && permission["system-branding--biddr_360"];
    }
    getDashboardTitle() {
        return this.getProductName() + " Dashboard";
    }
    getControlCenterTitle() {
        return this.getProductName() + " Control Center";
    }
    getProductSuiteTitle() {
        return this.getProductName() + " Product Suite";
    }
};
exports.BrandingService = BrandingService;
exports.BrandingService = BrandingService = __decorate([
    (0, core_1.Injectable)(),
    __metadata("design:paramtypes", [permission_service_1.PermissionService])
], BrandingService);
//# sourceMappingURL=branding.service.js.map